// extracted by mini-css-extract-plugin
export default {"modalOverlay":"HA-z","modalContent":"IA-z","header":"JA-z","close":"KA-z"};